import React from "react";
import { useParams } from "react-router-dom";
import { PageHeader } from "antd";
import { ShoppingOutlined } from "@ant-design/icons";
import { MyBreadcrumb } from "utils";
import ItemForm from "./form";

export default function ItemUpdate() {
  const { id } = useParams();
  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Items", path: "/billing/items" },
          { label: "Edit", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <ShoppingOutlined /> }}
        title="Edit Item"
        style={{ marginBottom: 16 }}
      />
      <ItemForm id={id} />
    </div>
  );
}
